import {
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftAddon,
  VStack,
} from '@chakra-ui/react';
import { maskPhoneNumber } from '@common/utility/masks';
import { phoneNumberRegExUS } from '@common/utility/validations';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSignUpModel } from '../../models/SignUpModel';
import { PageHeader } from './PageHeader';

type FormValues = { phone: string };

export const PhoneNumberForm: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { phone, setPhone } = useSignUpModel();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = handleSubmit(async (data) => {
    setIsLoading(true);
    await setPhone(data.phone);
    setIsLoading(false);
  });

  return (
    <Flex direction={'column'} gap={10} align="center">
      {/* Header */}
      <PageHeader
        title="Almost there, next we'll need your phone number"
        subtitle="We use this to make your account more secure with two-factor authentification. We will never use your number to send you spam or sell your info."
        step={4}
        steps={4}
      />

      {/* Form */}
      <VStack as="form" onSubmit={onSubmit} minW={['100%', '350px']} gap="10px">
        <FormControl
          isInvalid={Boolean(errors.phone)}
          as={Flex}
          alignItems={'center'}
          flexDir={'column'}
          justifyContent={'center'}>
          <InputGroup size="md" maxW={['full', 350]}>
            <InputLeftAddon children="+1" />
            <Input
              autoFocus={true}
              id="phone"
              mb={3}
              placeholder="123-456-7890"
              maxW={['full', 350]}
              defaultValue={phone}
              onInput={maskPhoneNumber}
              {...register('phone', {
                pattern: {
                  message: 'Please use a valid US phone number',
                  value: phoneNumberRegExUS,
                },
              })}
            />
          </InputGroup>

          <FormErrorMessage>{errors.phone && errors.phone.message}</FormErrorMessage>
        </FormControl>

        <Button
          isDisabled={Boolean(errors.phone) || isLoading}
          isLoading={isLoading}
          type="submit"
          w="full"
          p={7}
          maxW={['full']}>
          Continue
        </Button>
      </VStack>
    </Flex>
  );
};
